import { Link } from 'react-router-dom';
import footerVideo from '../../assets/footer.mp4';
import dhwaniLogo from '../../assets/dhwani_logo2.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="footer-video-section">
        <video
          className="footer-video"
          src={footerVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="footer-video-overlay"></div>
      </div>

      <div className="footer-glass-pane">
        <div className="footer-content-wrapper">

          {/* Brand Section */}
          <div className="footer-brand">
            <img src={dhwaniLogo} alt="Dhwani 2026 Logo" className="footer-brand-logo" />
            <p className="footer-tagline">Experience the fire of creativity and talent at South India's largest cultural fest.</p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/dhwani.cec?igsh=NHQ2MGJuYWkzbm43" target="_blank" rel="noreferrer" className="social-icon" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-instagram">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-links-group">
            <h4 className="footer-heading">Quick Links</h4>
            <ul>
              <li><a href="/#home">Home</a></li>
              <li><a href="/#events">Events</a></li>
              <li><Link to="/results">Results</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/brochure">Brochure</Link></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-contact">
            <h4 className="footer-heading">Get in Touch</h4>
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <p>CE Cherthala, Alappuzha, Kerala</p>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📧</span>
              <p><a href="mailto:dhwani26.cec@gmail.com">dhwani26.cec@gmail.com</a></p>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <p>
                <a href="tel:+916282310316">+91 6282310316</a><br />
                <a href="tel:+917591963454">+91 7591963454</a>
              </p>
            </div>
          </div>

        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>&copy; 2026 Dhwani Arts Fest. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;